import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=c1a32da4&scoped=true&"
import script from "./Points.vue?vue&type=script&lang=js&"
export * from "./Points.vue?vue&type=script&lang=js&"
import style0 from "./Points.vue?vue&type=style&index=0&id=c1a32da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a32da4",
  null
  
)

export default component.exports